import { useState } from "react";
import { AddOutlined } from "@mui/icons-material";
import { Box, Button, List, Typography, CircularProgress } from "@mui/material";
import { Fragment } from "react";
import { useDistributionLists } from "../hooks";
import { DistributionListItem } from ".";
import CreateDistributionListPopup from "./CreateDistributionListPopup";
import EditDistributionListPopup from "./EditDistributionListPopup";

export default function DistributionListManagement() {
  const { distributionLists, loading } = useDistributionLists();
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [newlyCreatedList, setNewlyCreatedList] = useState(null);
  
  return (
    <Fragment>
      <Box sx={{ mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<AddOutlined fontSize="inherit" />}
          onClick={() => setCreateOpen(true)}
          disabled={loading}
        >
          Add Distribution List
        </Button>
      </Box>
      <Box sx={{ maxHeight: 400, overflow: 'auto', mt: 2 }}>
        {loading && distributionLists.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <List
            sx={({ palette }) => ({
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              width: "100%",
              mr: "auto",
              "> li:not(:last-child)": {
                borderBottom: `1px solid ${palette.divider}`,
              },
            })}
          >
            {Array.isArray(distributionLists) && distributionLists.length > 0 ? (
              distributionLists.map((list) => (
                <DistributionListItem
                  distList={list}
                  key={`dist-list-${list.id}`}
                />
              ))
            ) : (
              <Box sx={{ py: 4, textAlign: 'center' }}>
                <Typography variant="body1" color="text.secondary">
                  No distribution lists created yet. Create your first one to get started!
                </Typography>
              </Box>
            )}
          </List>
        )}
      </Box>
      <CreateDistributionListPopup
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={(list) => {
          setCreateOpen(false);
          setNewlyCreatedList(list);
          setEditOpen(true);
        }}
      />

      {newlyCreatedList && (
        <EditDistributionListPopup
          open={editOpen}
          onClose={() => setEditOpen(false)}
          distributionList={newlyCreatedList}
        />
      )}
    </Fragment>
  );
}
